import routes from "routes";
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

export const useRouteName = () => {
  let name = "Dashboard";
  const {language} = useSelector( state => state.data);
  const location = useLocation();

  routes.forEach((route) => {
    const routePath = `${route.layout}${route.path}`.replace(/\/+$/, '');
    const currentPath = location.pathname.replace(/\/+$/, '');
    if (currentPath === routePath) {
      name = route.rtlActive ? route.rtlName : language === 'es' ? route.name : route.name_en;
      //console.log('current page:', name);
    }
  });
  return name;
};
